const sanitizeHtml = require('../../libs/sanitize-html.min');

const _this = {
    sanitizeString:function(input){
        if (!input) {
            return input;
        }

        if (typeof input != 'string') {
            return input;
        }

        try {
            return sanitizeHtml(input);
        } catch (error) {
            return input;
        }
    }
}

module.exports = _this;
